<script setup>
import { computed } from "vue";
import SharedPresence from "@/components/shared/SharedPresence";
import { useAuthStore } from "@/app/stores/authStore";

defineProps({
  title: {
    type: String,
    default: "",
  },
  small: {
    type: Boolean,
    default: false,
  },
  trackernet: {
    type: Boolean,
    default: false,
  },
  hideAsterisk: {
    type: Boolean,
    default: false,
  }
})

const authStore = useAuthStore();

const hasRoleCollaborator = computed(() => {
  return !!authStore.getUserLogged?.roles?.includes("ROLE_EXTERNAL_COLLABORATOR")
}) 
</script>

<template>
  <div id="header-title" :class="{ small, 'with-presence': trackernet && !hasRoleCollaborator }">
    <div class="header-content">
      <div class="header-left">
        <h1>
          {{ title }}
          <svg v-if="!hideAsterisk" id="asterisk" xmlns="http://www.w3.org/2000/svg" width="724" height="1024" viewBox="0 0 724 1024">
            <path
              d="M0 499.8l59-181.7 332.5 108.6-59 180.8-332.5-107.7zM79.6 744.3l206.1-282.9 154.5 111.5-206.1 283.8-154.5-112.4zM266.9 167.3h191.1v350.3h-191.1v-350.3zM285.6 572.9l154.5-111.5 206.1 282.9-154.5 112.4-206.1-283.8zM332.5 426.8l332.5-108.6 59 181.7-331.6 107.7-59.9-180.8z" />
          </svg>
        </h1>
      </div>
      <div class="header-right" v-if="trackernet && !hasRoleCollaborator">
        <shared-presence />
      </div>

    </div>
  </div>
</template>

<style scoped lang="scss">
#header-title {
  background: rgba(114, 119, 245, 1);
  background: -moz-linear-gradient(left, rgba(114, 119, 245, 1) 0%, rgba(109, 111, 244, 1) 12%, rgba(83, 88, 235, 1) 75%, rgba(71, 77, 230, 1) 100%);
  background: -webkit-gradient(left top, right top, color-stop(0%, rgba(114, 119, 245, 1)), color-stop(12%, rgba(109, 111, 244, 1)), color-stop(75%, rgba(83, 88, 235, 1)), color-stop(100%, rgba(71, 77, 230, 1)));
  background: -webkit-linear-gradient(left, rgba(114, 119, 245, 1) 0%, rgba(109, 111, 244, 1) 12%, rgba(83, 88, 235, 1) 75%, rgba(71, 77, 230, 1) 100%);
  background: -o-linear-gradient(left, rgba(114, 119, 245, 1) 0%, rgba(109, 111, 244, 1) 12%, rgba(83, 88, 235, 1) 75%, rgba(71, 77, 230, 1) 100%);
  background: -ms-linear-gradient(left, rgba(114, 119, 245, 1) 0%, rgba(109, 111, 244, 1) 12%, rgba(83, 88, 235, 1) 75%, rgba(71, 77, 230, 1) 100%);
  background: linear-gradient(to right, rgba(114, 119, 245, 1) 0%, rgba(109, 111, 244, 1) 12%, rgba(83, 88, 235, 1) 75%, rgba(71, 77, 230, 1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#7277f5', endColorstr='#474de6', GradientType=1);
  height: 140px;
  margin: -10px -80px 20px -50px;

  &.small {
    height: 80px;
    margin: 0 0 20px;
  }

  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 100%;
    padding: 0 40px;
  }

  .header-left {
    display: flex;
    align-items: center;

    //width: 1200px;
    h1 {
      color: white;
      text-align: left;
      font-size: 4em;
      font-weight: 900;
      letter-spacing: -0.05em;
      padding-left: 40px;
      padding-top: 15px;

      #asterisk {
        position: absolute;
        vertical-align: super;
        height: auto;
        width: 0.5em;
        fill: $yellow-color;
        margin-left: 15px;
      }
    }
  }

  .header-right {
    color: white;
  }
}

// Keep presence in the same row and compact only the title on smaller desktops.
@media (min-width: 993px) and (max-width: 1600px) {
  #header-title.with-presence {
    .header-content {
      flex-wrap: nowrap;
      column-gap: 24px;
      padding-left: 24px;
    }

    .header-left h1 {
      font-size: clamp(26px, 3vw, 44px) !important;
      padding-left: 0;
      padding-right: 36px;
      white-space: nowrap;
    }

    .header-right {
      flex-shrink: 0;
    }
  }
}

// Preserve the title clearance when the global compact margins end at 1440px.
@media (min-width: 1441px) and (max-width: 1600px) {
  #header-title.with-presence:not(.small) .header-content {
    padding-left: 44px;
  }
}

@media (min-width:1440px) {
  .header-right {
    color: white;
    padding-right: 40px;
  }
}

@media (max-width: 767px) {
  #header-title {
    height: 80px !important;
  }

  .header-left {
    h1 {
      padding-left: 0px !important;
      font-size: 35px !important;
    }
  }
}
</style>
